import React from 'react';
import PropTypes from 'prop-types';

import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';
import { AlertsToggle } from 'site-modules/profile/components/dashboard/alerts-toggle/alerts-toggle';
import { PriceDropAlertsBanner } from 'site-modules/profile/components/dashboard/price-drop-alerts-banner/price-drop-alerts-banner';
import { VinCardsLanding } from 'site-modules/profile/components/dashboard/vin-cards-landing/vin-cards-landing';
import { RecentlyViewedVins } from 'site-modules/profile/components/dashboard/recently-viewed-vins/recently-viewed-vins';
import { withCompareVehicleTray } from 'site-modules/shared/components/compare-vehicle-tray-wrapper/compare-vehicle-tray-wrapper';

const TRACKING_PARENT = 'edm-entry-dashboard-inventory';

function InsiderInventoryDashboardUI({
  removeDataFromIdm,
  updateIdmData,
  onSelectCar,
  selectedCars,
  isAuthenticated = null,
  isMain = false,
}) {
  const InventoryDashboardAlertBanner = isMain ? PriceDropAlertsBanner : AlertsToggle;
  const compareSelect = {
    onSelect: onSelectCar,
    selectedCars,
  };

  return (
    <div className="insider-inventory-dashboard">
      <div data-tracking-parent={TRACKING_PARENT}>
        <ErrorBoundary>
          <InventoryDashboardAlertBanner className="mb-2" showSetupAlertLink showPriceDropAlerts />
        </ErrorBoundary>
        <ErrorBoundary>
          <VinCardsLanding
            isAuthenticated={isAuthenticated}
            updateIdmData={updateIdmData}
            deleteVinFromIdm={removeDataFromIdm}
            compareSelect={compareSelect}
          />
        </ErrorBoundary>
      </div>
      <div data-tracking-parent="edm-entry-recently-viewed">
        <ErrorBoundary>
          <RecentlyViewedVins compareSelect={compareSelect} />
        </ErrorBoundary>
      </div>
      <p className="size-12 py-1">
        * Delivery of any kind does not apply to Alaska and Hawaii. Contact the dealer for delivery details,
        restrictions and costs.
      </p>
    </div>
  );
}

InsiderInventoryDashboardUI.propTypes = {
  removeDataFromIdm: PropTypes.func.isRequired,
  updateIdmData: PropTypes.func.isRequired,
  onSelectCar: PropTypes.func.isRequired,
  selectedCars: PropTypes.arrayOf(PropTypes.object).isRequired,
  isAuthenticated: PropTypes.bool,
  isMain: PropTypes.bool,
};

export const InsiderInventoryDashboard = withCompareVehicleTray(InsiderInventoryDashboardUI, {
  trackingParent: `${TRACKING_PARENT}-compare-tray`,
  isVinCompare: true,
  source: 'insider',
  backFocusLink: {
    label: 'Skip to saved inventory',
    selector: '.compare-select .checkbox input',
  },
});
